export const Theme = {
  Tabs : {
    flex : '1 1 auto'
  },
  TabVertical: {
    outline: 'none',
    boxShadow: 'none',
    fontSize: '12px',
    justifyContent: 'flex-start',
    minWidth: '200px',
    border: '0px',
    color: '#2c2c2c'
  },
  TabVerticalActive : {
    background : '#f5f5f5',
    fontWeight: '600'
  },
  FormControl : {
    padding : '10px 30px',
    margin : 0,
  },
  Panels : {
    padding : 0,
  },
  Panel : {
    margin : 0,
    padding: 0,
    background : '#f5f5f5',
    height: '100%'
  },
  Field : {
    background : '#fff',
    borderRadius : 0,
    border: '1px solid #a1a1a1',
    fontFamily: 'monospace'
  },
  Label : {
    fontSize: '14px',
    fontWeight: '500'
  },
  Container : {
    flex: 1,
    width: '100%',
    margin: 0,
    padding: 0,
    maxWidth: '100%',
  },
  Loader : {
    background : 'rgba(255,255,255,0.7)',
    position : 'fixed',
    width : '100%',
    height: '100%',
    top : '0',
    left : '0',
    right : '0',
    bottom : '0',
    display : 'flex',
    alignItems : 'center',
    justifyContent : 'center',
    zIndex : 1000
  },
  StackScroll : {
    maxHeight: '80px',
    overflowY: 'auto',
    overflowX: 'hidden'
  }
}